// SCRIPTS
// import './scripts/exampleGsapAnimation';
import './scripts/gravityFormsOverride';
import './scripts/header';
import './scripts/sliders';
import './scripts/mobileNav';
import './scripts/tableOfContents';
import './scripts/share';
import './scripts/copyToClipboard';
import './scripts/gallery';

const addToCalendars = document.querySelector('.js-add-calendar');
if (addToCalendars) {
	import('./scripts/addToCalendars').then(module => {
		module;
	});
}

const programsInclude = document.querySelector('.js-program-include-nav');
if (programsInclude) {
	import('./scripts/programsInclude').then(module => {
		module;
	});
}

const accordions = document.querySelector('.js-accordions-hld');
if (accordions) {
	import('./scripts/accordions').then(module => {
		module;
	});
}


